


import "tailwindcss/tailwind.css"
import 'animate.css';
import PageTwo from './hero.js'
import PageOne from './head.js'
import PageThree from './features.js'
import { useState, useEffect, useRef } from 'react'
import React from "react";
import Slider from "react-slick";
import { MyProcess } from './process.js';
import { fadeIn, flash, slideInUp } from 'react-animations';
import { StyleSheet, css } from 'aphrodite';
import Header from './header'
import AOS from 'aos'
import 'aos/dist/aos.css'
import './page.css'
import { PopupProvider } from './components/PopupContext'

const animationTime = '1.2s';
export default function App() {
  const [pageNum, setPageNum] = useState(1);
  const [imageIndex, setImageIndex] = useState(0);
  const swipeRef = useRef(null);
  const textFlowRef = useRef(null);
  const styles = StyleSheet.create({
    fadeIn: {
      animationName: fadeIn,
      animationDuration: animationTime
    }, flash: {
      animationName: flash,
      animationDuration: animationTime
    }, slideInUp: {
      animationName: slideInUp,
      animationDuration: animationTime
    },
  })
  const swiperNumber = function (oldIndex, newIndex) {
    setImageIndex(newIndex);
  }


  const handleWheel = (event) => {
    const div = document.getElementById('contain-page');
    const isScrolledToBottom = div.scrollHeight - div.clientHeight <= div.scrollTop + 1;
    const deltaY = event.deltaY;
    if (pageNum === 2) {
      if (window.lock) {
        return;
      }
      if (deltaY < 0 && imageIndex !== 0) {

        swipeRef.current.slickPrev();
        window.lock = true;
        setTimeout(() => {
          window.lock = false;
        }, 1000)
        return;
      } else if (deltaY > 0 && imageIndex !== 2) {
        swipeRef.current.slickNext();
        window.lock = true;
        setTimeout(() => {
          window.lock = false;
        }, 1000)
        return;
      }


    }
    if (window.lock) {
      return;
    }
    if (deltaY > 0 && isScrolledToBottom) {
      setPageNum((prevPageNum) => {
        if (prevPageNum === 3) {
          return 3;
        } else {

          div.scrollTo({
            top: 0,
            behavior: 'auto'
          });
          window.lock = true;
          setTimeout(() => {
            window.lock = false;
          }, 1000)
          return prevPageNum + 1;
        }

      });
    } else if (deltaY < 0 && div.scrollTop === 0) {
      setPageNum((prevPageNum) => {
        if (prevPageNum === 1) {
          return 1;
        } else {
          div.scrollTo({
            top: 0,
            behavior: 'auto'
          });

          window.lock = true;
          setTimeout(() => {
            window.lock = false;
          }, 1000)
          return prevPageNum - 1;
        }


      });
    }
  };

  useEffect(() => {

    AOS.init({
      once: true,
      disable: 'phone',
      duration: 700,
      easing: 'ease-out-cubic',
    })
    document.body.style.overflow = 'hidden';

    window.addEventListener("wheel", handleWheel, { passive: false });
    return () => {
      window.removeEventListener("wheel", handleWheel);
    };

  }, [pageNum, imageIndex]);
  var settings = {
    vertical: true, infinite: false,
    fade: true,
    speed: 1000,
    initialSlide: imageIndex, swipe: false,
    arrows: false
  };

  return (
    <PopupProvider>
      <div className='w-screen h-screen  overflow-x-hidden bg-black-100 relative' id="contain-page" style={{ backgroundImage: pageNum === 3 ? `url(${process.env.PUBLIC_URL}/images/page3_bg.png)` : '', backgroundSize: pageNum === 3 ? '100% 100%' : '' }}>
        <Header></Header>

        {pageNum === 1 && <div className={css(styles.fadeIn)}><PageOne /></div>}
        {pageNum === 2 && <div className={css(styles.fadeIn)}><PageTwo /></div>}
        {pageNum === 3 && <div className={css(styles.slideInUp)} > <PageThree textFlowRef={textFlowRef} /></div>}
        <div className='w-screen h-screen  overflow-hidden absolute top-[0px]' >
          <div id='pics' className=' md:w-[1170px] md:h-[860px] 2xl:w-[1462px] 2xl:h-[1075px] absolute justify-center  mx-auto child-container items-center flex flex-col [&::-webkit-scrollbar]:hidden  left-1/2  items-center ' style={{ left: pageNum === 1 || pageNum === 2 ? "50%" : '9999px', backgroundImage: pageNum === 1 ? `url(${process.env.PUBLIC_URL}/images/twoscreen.png)` : "", backgroundSize: pageNum === 1 ? '100% 100%' : "", top: pageNum === 1 ? "473px" : `calc(50vh - ${window.innerWidth > 1536 ? '537' : '429'}px)`, transform: pageNum === 1 ? 'translate(-50%,0)' : 'translate(-50%,0)' }}  >
            <Slider  {...settings} className=' md:w-[1170px] md:h-[860px] 2xl:w-[1462px] 2xl:h-[1075px]  [&::-webkit-scrollbar]:hidden ' ref={swipeRef} beforeChange={swiperNumber} >

              <img src={`${process.env.PUBLIC_URL}/images/yxq_v2.png`} alt="" className=' md:w-[1170px] md:h-[860px] 2xl:w-[1462px] 2xl:h-[1073px]' />

              <img src={`${process.env.PUBLIC_URL}/images/fx_v2.png`} alt="" className=' md:w-[1170px] md:h-[860px] 2xl:w-[1462px] 2xl:h-[1073px]' />

              <img src={`${process.env.PUBLIC_URL}/images/hyhd_v2.png`} alt="" className=' md:w-[1170px] md:h-[860px] 2xl:w-[1462px] 2xl:h-[1073px]' /> </Slider>

            <div style={{ position: 'absolute', right: '-100px' }}>
              {pageNum === 2 && <MyProcess selectedIndex={imageIndex} handleChange={function (index) {
                swipeRef.current && swipeRef.current.slickGoTo(index)
              }} />}
            </div>

          </div></div>
      </div>
    </PopupProvider>
  )
}
